export default __webpack_public_path__ + "static/media/holder.4cd85700.jpg";